import { EditInvestor } from '@/components/investors-page/editInvestorPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const EditInvestorPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Edit Investor</title>
      </Head>
      <EditInvestor />
    </>
  );
};

export default EditInvestorPage;
